import { FunctionComponent } from 'react';
import qualityAmazingOriginPng from '../../../../../assets/internet-availability/quality-amazing-origin.png';
import qualityExcellentEligiblePng from '../../../../../assets/internet-availability/quality-excellent-eligible.png';
import qualityExcellentOriginPng from '../../../../../assets/internet-availability/quality-excellent-origin.png';
import qualityAdequateOriginPng from '../../../../../assets/internet-availability/quality-adequate-origin.png';
import qualityAdequateEligiblePng from '../../../../../assets/internet-availability/quality-adequate-eligible.png';
import qualityLimitedOriginPng from '../../../../../assets/internet-availability/quality-limited-origin.png';
import qualityLimitedPng from '../../../../../assets/internet-availability/quality-limited-rebrand.png';
import styled from 'styled-components';
import { ConnectionQuality } from '../../InternetAvailabilityBrickV2';

const ConnectionQualityGaugeImage = styled.img`
  width: 93.28px;
  height: 100%;
`;

const ConnectionQualityMapper: Record<ConnectionQuality, string> = {
  ADEQUATE: qualityAdequateOriginPng,
  ADEQUATE_ELIGIBLE: qualityAdequateEligiblePng,
  AMAZING: qualityAmazingOriginPng,
  EXCELLENT: qualityExcellentOriginPng,
  EXCELLENT_ELIGIBLE: qualityExcellentEligiblePng,
  LIMITED: qualityLimitedOriginPng,
  LIMITED_UNTHEMED: qualityLimitedPng,
};

interface ConnectionQualityGaugeProps {
  connectionQuality: ConnectionQuality;
}

export const ConnectionQualityGauge: FunctionComponent<ConnectionQualityGaugeProps> = ({
  connectionQuality,
}) => {
  return (
    <ConnectionQualityGaugeImage
      alt={`${connectionQuality.toLowerCase()}-connection-quality-logo`}
      src={ConnectionQualityMapper[connectionQuality]}
    />
  );
};
